/**
 * 인사평가공통 상태 관리 스토어
 * 목적: 인사평가 공통 상태 및 검색 조건 관리
 */
import { defineStore } from 'pinia';
import { useCommonStore } from '../useCommonStore';
import { useCommonApi} from "~/composables/useCommonApi";

export const useHrEvaluationStore = defineStore('hrEvaluation', () => {
  // useCommonStore 인스턴스 가져오기
  const commonStore = useCommonStore();
  const commonApi = useCommonApi();

  // 인사평가 차수 조회
  const getEvalCycleList = async (year: string) => {
    if(!year && commonStore.findYear){
      year = commonStore.findYear;
    }
    const params = new URLSearchParams();
    params.append('findYear', year);
    const result = await commonApi.fetchSelectEvalCycleList(params);
    if(result.evalCycleList){
      return result.evalCycleList.map(
        (item: { evalCycleCd: any; evalCycleNm: any }) => ({
          id: item.evalCycleCd,
          label: item.evalCycleNm
        })
      );
    }
    return null;
  };
  
  return {
    getEvalCycleList
  };
});
